<list-view [liste]="geographieService.listeDistances" *ngIf="geographieService.listeDistances"></list-view>
<floating-button [listeActions]="listeActions"></floating-button>